module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-refundable-records"
  }, [_c('ModalReveal', {
    ref: _vm.componentId
  }, [_c('button', {
    staticClass: "button danger",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Select records")]), _c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h2', [_vm._v("Select records to refund")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column large-6"
  }, [_c('label', [_vm._v("Invoice final sectional / Internal id"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.invoice_id),
      expression: "search.invoice_id"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.invoice_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "invoice_id", $event.target.value)
      }
    }
  })])])])]), _c('div', {
    staticClass: "row column"
  }, [_c('base-list', {
    attrs: {
      "id": "refundable-list",
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "search": _vm.search,
      "resultsPerPage": 5,
      "selectableList": true
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _c('button', {
    staticClass: "button",
    attrs: {
      "slot": "footer"
    },
    on: {
      "click": _vm.close
    },
    slot: "footer"
  }, [_vm._v("Add records")]), _c('button', {
    staticClass: "button alert float-right",
    attrs: {
      "slot": "footer"
    },
    on: {
      "click": function($event) {
        return _vm.$refs[_vm.componentId].close()
      }
    },
    slot: "footer"
  }, [_vm._v("Close")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-115eec31!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/reveal/RefundableWalletRecords.vue
// module id = 2149
// module chunks = 1